import React from "react";
import PropTypes from "prop-types";
import {
  Button
} from '@mui/material';


export default function RegularButton(props) {
  const {
    color,
    round,
    children,
    disabled,
    simple,
    size,
    block,
    link,
    variant,
    justIcon,
    className,
    muiClasses,
    ...rest
  } = props;

  return (
    <Button {...rest} color="primary" disabled={disabled}  size={size} variant={variant} style={{margin:1, textTransform: 'none'}}>
    {children}
    </Button>
  );
}

RegularButton.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "transparent",
  ]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object,
  children: PropTypes.node,
  variant:PropTypes.string
};
